export const MAX_INPUT = Math.pow(2, 31) - 1;
export const MIN_INPUT = 0;
